import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Tax from "../../../containers/modules/master/tax";

export default function TaxRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="tax"
      index
      element={
        <AccessControl
          name={"Tax List"}
          auth={authUser}
          component={() => <Tax authUser={authUser} />}
        />
      }
    />
  );
}
